import Axios from '../axios'
import { TFunction } from 'i18next'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError, showBlob } from '../../../shared'
import appConfig from '../../../app.config'

async function getDepositAccountStatementService(
	accountStatementId: string,
	fileName: string,
	t: TFunction,
	windowRef: Window | null,
) {
	try {
		let response = await Axios.get<any>(
			`${appConfig.customerDataBaseUrl}/api/deposit/accountstatement?accountStatementId=${accountStatementId}`,
			{
				...(await getHeadersWithJwtToken()),
				responseType: 'blob',
			},
		)
		let blob = new Blob([response.data], {
			type: 'application/pdf',
		})
		showBlob(blob, windowRef, accountStatementId + '.pdf')
	} catch (e: any) {
		logError(e)
		throw new Error(t('ErrorAccountStatements'))
	}
}

export default getDepositAccountStatementService
